/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Toast_SentInputs */

const en_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message sent. Mark will get back to you soon.`)
};

const es_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensaje enviado. Mark te responderá pronto.`)
};

const de_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht gesendet. Mark wird sich bald bei Ihnen melden.`)
};

const zh_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消息已发送。Mark 很快就会回复你。`)
};

const ar_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم إرسال الرسالة. سيردّ Mark عليك قريباً.`)
};

const fr_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message envoyé. Mark vous répondra bientôt.`)
};

const vi_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gửi tin nhắn. Mark sẽ phản hồi bạn sớm.`)
};

const sw_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ujumbe umetumwa. Mark atawasiliana nawe hivi karibuni.`)
};

const th_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่งข้อความแล้ว Mark จะติดต่อกลับเร็วๆ นี้`)
};

const bs_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poruka poslana. Mark će vam se uskoro javiti.`)
};

const ja_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージを送信しました。Markより折り返しご連絡いたします。`)
};

const ko_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메시지가 전송되었습니다. Mark가 곧 연락드리겠습니다.`)
};

const pt_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem enviada. Mark vai retornar em breve.`)
};

const it_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messaggio inviato. Mark ti risponderà presto.`)
};

const sv_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meddelandet har skickats. Mark återkommer snart.`)
};

const nl_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht verzonden. Mark belt je snel terug.`)
};

const da_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besked sendt. Mark ringer snart tilbage.`)
};

const nb_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen er sendt. Mark tar snart kontakt med deg.`)
};

const fi_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viesti lähetetty. Mark soittaa pian.`)
};

const pl_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiadomość wysłana. Mark niedługo do ciebie oddzwoni.`)
};

const ru_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщение отправлено. Mark скоро вам ответит.`)
};

const tr_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesaj gönderildi. Mark yakında size geri dönecek.`)
};

const hi_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संदेश भेज दिया गया। Mark जल्द ही आपसे संपर्क करेंगे।`)
};

const id_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan dikirim. Mark akan segera menghubungi Anda.`)
};

const ms_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesej dihantar. Mark akan menghubungi anda tidak lama lagi.`)
};

const cs_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpráva odeslána. Mark se vám brzy ozve.`)
};

const el_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Το μήνυμα στάλθηκε. Ο Mark θα επικοινωνήσει σύντομα μαζί σας.`)
};

const he_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ההודעה נשלחה. Mark יחזור אליכם בקרוב.`)
};

const af_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boodskap gestuur. Mark sal binnekort by jou terugkom.`)
};

const hu_contact_toast_sent = /** @type {(inputs: Contact_Toast_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üzenet elküldve. Mark hamarosan visszahív.`)
};

/**
* | output |
* | --- |
* | "Message sent. Mark will get back to you soon." |
*
* @param {Contact_Toast_SentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_toast_sent = /** @type {((inputs?: Contact_Toast_SentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Toast_SentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_toast_sent(inputs)
	if (locale === "de") return de_contact_toast_sent(inputs)
	if (locale === "zh") return zh_contact_toast_sent(inputs)
	if (locale === "ar") return ar_contact_toast_sent(inputs)
	if (locale === "fr") return fr_contact_toast_sent(inputs)
	if (locale === "vi") return vi_contact_toast_sent(inputs)
	if (locale === "sw") return sw_contact_toast_sent(inputs)
	if (locale === "th") return th_contact_toast_sent(inputs)
	if (locale === "bs") return bs_contact_toast_sent(inputs)
	if (locale === "ja") return ja_contact_toast_sent(inputs)
	if (locale === "ko") return ko_contact_toast_sent(inputs)
	if (locale === "pt") return pt_contact_toast_sent(inputs)
	if (locale === "it") return it_contact_toast_sent(inputs)
	if (locale === "sv") return sv_contact_toast_sent(inputs)
	if (locale === "nl") return nl_contact_toast_sent(inputs)
	if (locale === "da") return da_contact_toast_sent(inputs)
	if (locale === "nb") return nb_contact_toast_sent(inputs)
	if (locale === "fi") return fi_contact_toast_sent(inputs)
	if (locale === "pl") return pl_contact_toast_sent(inputs)
	if (locale === "ru") return ru_contact_toast_sent(inputs)
	if (locale === "tr") return tr_contact_toast_sent(inputs)
	if (locale === "hi") return hi_contact_toast_sent(inputs)
	if (locale === "id") return id_contact_toast_sent(inputs)
	if (locale === "ms") return ms_contact_toast_sent(inputs)
	if (locale === "cs") return cs_contact_toast_sent(inputs)
	if (locale === "el") return el_contact_toast_sent(inputs)
	if (locale === "he") return he_contact_toast_sent(inputs)
	if (locale === "af") return af_contact_toast_sent(inputs)
	if (locale === "hu") return hu_contact_toast_sent(inputs)
	return en_contact_toast_sent(inputs)
});